import { SiteOsCard, SiteWhatsAppThread } from '../SiteUi';

export function SiteHeroDemo() {
  return (
    <div data-hero-animated-stage className="relative mx-auto max-w-md">
      <SiteOsCard className="w-full" />
      <div className="flex flex-col items-center py-3 text-center">
        <span className="h-6 w-px bg-[#d9d4cc]" aria-hidden />
        <p className="my-1.5 font-os text-[11px] tracking-[0.18em] text-[#f5821f]">90 DIAS DEPOIS</p>
        <span className="h-6 w-px bg-[#d9d4cc]" aria-hidden />
      </div>
      <SiteWhatsAppThread className="w-full" />
      <p className="mt-3 text-center text-sm text-[#1f6b43]">Cliente respondeu sozinho</p>
      <div className="sr-only" data-hero-static-fallback>
        OS #1042 finalizada. Lembrete enviado no WhatsApp. Cliente confirmou o retorno. Venda registrada no caixa.
      </div>
    </div>
  );
}
